import MainContainer from './containers/main';

export const COMICS_PATHNAME = '/comics';
export const COMIC_PATH = '/comics/:slug?';


export default [
    {
        component: MainContainer,
        path: COMIC_PATH,
    }
]



// WEBPACK FOOTER //
// ./src/client/routes.js